import React from "react";

const InnerLoader = ({
  className,
  divSize = {
    width: "48px",
    height: "48px",
  },
  loaderSize = {
    width: "32px",
    height: "32px",
  },
}) => {
  return (
    <div
      className={`${className} relative`}
      style={{
        width: divSize.width,
        height: divSize.height,
      }}
    >
      <div
        className="rounded-full absolute
                            border-2 border-solid border-gray-200 shadow-md"
        style={{
          width: loaderSize.width,
          height: loaderSize.height,
        }}
      ></div>

      <div
        className="rounded-full animate-spin absolute
                            border-2 border-solid border-primary-green border-t-transparent shadow-sm"
        style={{
          width: loaderSize.width,
          height: loaderSize.height,
        }}
      ></div>
    </div>
  );
};

export default InnerLoader;
